const ACCESS_TOKEN_KEY = 'H_A_T'

const REFRESH_TOKEN_KEY = 'H_R_T'

export { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY }
